export default "__VITE_ASSET__h$H7t0Ha__"